<template>
  <div>
    <h2>商品一覧</h2>
    <div class="product-list">
      <div
        class="product"
        v-for="product in products"
        :key="product.product_id"
        @click="viewProduct(product.product_id)"
      >
        <img :src="getImageUrl(product.image_url)" :alt="product.name" class="product-image" />
        <h3>{{ product.name }}</h3>
        <p>価格: ¥{{ product.price.toLocaleString() }}</p>
        <p>残り在庫: {{ product.stock_quantity }}個</p> <!-- 残り在庫を表示 -->
        <button @click.stop="addToCart(product)" :disabled="product.stock_quantity <= 0">カートに追加</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'ProductList',
  setup() {
    const router = useRouter();
    const store = useStore();
    const products = ref([]);

    const fetchProducts = async () => {
      try {
        const response = await fetch('http://172.16.80.71:5000/api/products');
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        products.value = data; // APIから取得した商品データをセット

        // デバッグ情報を追加
        console.log('Fetched products:', products.value);
      } catch (error) {
        console.error('商品取得に失敗:', error);
      }
    };

    const getImageUrl = (imagePath) => {
      return imagePath ? require(`@/assets/images/${imagePath}`) : require('@/assets/images/default.png');
    };

    const viewProduct = (id) => {
      router.push({ name: 'ProductDetail', params: { id } });
    };

    const addToCart = (product) => {
      // 在庫数量を確認するためにデバッグ情報を追加
      console.log('Adding to cart:', product);
      if (product.stock_quantity > 0) {
        store.commit('addToCart', { ...product, quantity: 1 });
        alert(`${product.name}をカートに追加しました！`);
      } else {
        alert('在庫がありません。');
      }
    };

    onMounted(fetchProducts); // コンポーネントがマウントされたときに商品データを取得

    return {
      products,
      viewProduct,
      addToCart,
      getImageUrl,
    };
  },
};
</script>

<style>
.product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.product {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  text-align: center;
}
.product-image {
  width: 100px;
  height: auto;
  margin-bottom: 10px;
}
</style>